import React from 'react';
import FormSelect from 'shared/forms/FormSelect';
import { useSelector } from 'react-redux';
import { getUsers } from 'src/slices/users';
import { FormMultiSelect } from '../formControls';

const UsersDropdown = (props) => {
  const users = useSelector(getUsers).map((x) => ({ id: x.id, name: x.displayName }));
  const value = props.multiSelect ? (props.value?.map((v) => (typeof (v) === 'object' ? v : users.find((x) => x.id === v)))) : (typeof props.value === 'object' ? props.value : users.find((x) => x.id == props.value));
  const SelectComponent = props.multiSelect ? FormMultiSelect : FormSelect;

  return (
    <>
      <SelectComponent
        data={users}
        textField="name"
        dataItemKey="id"
        {...props}
        value={value}
      />
    </>
  );
};

export default UsersDropdown;